import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CostUnitGroupContributionMarginLevelAssignmentsDialogModule } from './cost-unit-group-contribution-margin-level-assignments-dialog/cost-unit-group-contribution-margin-level-assignments-dialog.module';
import { CostUnitGroupCostUnitAssignmentsDialogModule } from './cost-unit-group-cost-unit-assignments-dialog/cost-unit-group-cost-unit-assignments-dialog.module';
import { CostUnitGroupDialogModule } from './cost-unit-group-dialog/cost-unit-group-dialog.module';
import { CostUnitGroupPage } from './cost-unit-group.page';


export * from './cost-unit-group.page';
export * from './cost-unit-group-dialog/cost-unit-group-dialog.module';
export * from './cost-unit-group-cost-unit-assignments-dialog/cost-unit-group-cost-unit-assignments-dialog.module';
export * from './cost-unit-group-contribution-margin-level-assignments-dialog/cost-unit-group-contribution-margin-level-assignments-dialog.module';



const routes: Routes = [
    {
        path: '',
        component: CostUnitGroupPage,
    },
];

@NgModule({
    declarations: [ CostUnitGroupPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        CostUnitGroupDialogModule,
        CostUnitGroupCostUnitAssignmentsDialogModule,
        CostUnitGroupContributionMarginLevelAssignmentsDialogModule,
        MatProgressBarModule,
        MatTableModule,
        MatPaginatorModule,
        MatBadgeModule,
        MatSortModule,
        MatTooltipModule
    ],
})
export class CostUnitGroupPageModule {
}
